import { postMethodByCallBack, cacheTypes, getMethodByCallBack } from "../../../store/api/CommonFunctions";

export function addNewTempalte(data, onAdd) {
    postMethodByCallBack("api/SMSAPI/AddNewTemplate", data, onAdd, "ADD_SMS_TEMPLATE");
}
export function editTempalte(data, onEdit) {
    postMethodByCallBack("api/SMSAPI/EditTemplate", data, onEdit, "EDIT_SMS_TEMPLATE");
}
export function getSMSTemplates(templateType, onGetData) {
    getMethodByCallBack(`api/SMSAPI/GetTemplates?templateType=${templateType}`, cacheTypes.NoCache, onGetData, "GET_SMS_TEMPLATES");
}
export function deleteSMSTemplate(id, onGetData) {
    getMethodByCallBack(`api/SMSAPI/DeleteTemplate?id=${id}`, cacheTypes.NoCache, onGetData, "DELETE_SMS_TEMPLATE");
}
export function searchSentSMS(data, onGetData) {
    onGetData("PENDING");
    postMethodByCallBack("api/SMSAPI/SearchSentSMS", data, onGetData, "SEARCH_SENT_SMS");
}
export function searchReceivedSMS(data, onGetData) {
    postMethodByCallBack("api/SMSAPI/SearchReceivedSMS", data, onGetData, "SEARCH_RECEIVED_SMS");
}